import { useState, useEffect } from 'react';
import "./verticalHeads.css";

const BREAKPOINT = 1015;

function isMobile() {
  return window.innerWidth < BREAKPOINT;
}

const Stuff = () => {
  

  const link1 = "https://www.nathalieobadia.com/exhibitions/358-jerome-zonder-portraits-du-paradis/works/"

  const link2 = "https://suzanne-tarasieve.com/en/chateau-de-rentilly"

  const link3 = "https://artfacts.net/exhibition/cecily-brown-a-sunset-a-ruin-a-crowd-and-a-battle-thomas-dane-gallery-london-2026"

  const link4 = "https://reflexamsterdam.com/exhibitions/enoc-perez"

  const headlines = [
      { title: "Jerome Zonder", sub: "portraits du paradis", link: link1 },
      { title: "Suzanne Tarasieve", sub: "Château de Rentilly", link: link2 }, 
      { title: "Cecily Brown", sub: " A Sunset, a Ruin, a Crowd, and a Battle", link: link3 },
      {title:"Enoc Perez", sub:"Drawings & Selected Paintings", link:link4}
  ]
 // const headlines = [headline1, headline2, headline3, headline4] 29th october last updated;

  // Duplicate the list so the animation loops smoothly
  const items = [...headlines, ...headlines]
  if (isMobile()) {
    return null;
  }
  return (
    <div className="headline-container">
      <span>Inspired by</span>
    <div className="headline-track">
      {items.map((headline, index) => (
        <div className="headline">
        <h4 key={index} className="ruben">
          {headline.title}
          </h4>
          <p><a href={headline.link} target="_blank" rel="noreferrer">{ headline.sub}</a></p>
          </div>
      ))}
    </div>
  </div>

  );
};

export default Stuff;
